import React, { FunctionComponent } from "react";

import { ITestable } from "@/browser";
import { Icon } from "@/components/Icon";

import { ISkillBadgeActionProps, SkillBadge } from "./components";

export interface ISkillRemoveProps extends ISkillBadgeActionProps, ITestable {
  onClick: () => void;
}

export const SkillRemove: FunctionComponent<ISkillRemoveProps> = ({ children, onClick, text, testName, ...rest }) => {
  return (
    <SkillBadge {...rest} className="skill-badge-remove" text={text} onClick={onClick} testName={testName}>
      {children && <div onClick={e => e.stopPropagation()}>{children}</div>}
      <Icon size="md" icon="close" color="grey2" />
    </SkillBadge>
  );
};
